import React from "react";
import { NakiMobileHandheldPinkFeaturedSectionTemplate } from "themes/administration/naki-mobile/pages";
import { NakiMobileHandheldPinkFeaturedSectionViewStore } from "administration/naki-mobile/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new NakiMobileHandheldPinkFeaturedSectionViewStore(rootStore, componentProps),
    "nakiMobileHandheldPinkFeaturedSectionViewStore"
)
class NakiMobileHandheldPinkFeaturedSection extends React.Component {
    render() {
        return <NakiMobileHandheldPinkFeaturedSectionTemplate {...this.props} />;
    }
}

export default NakiMobileHandheldPinkFeaturedSection;
